import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
export default {
    methods: {
        //获取班级列表 GET api/NetWorkCheck/GetClassList
        GetClassList(Id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                Id: Id
            };
            this.loading = true;
            $http.get("api/NetWorkCheck/GetClassList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.classList = Data
                });
            });
        },
        //修改班级提交 GET /api/NetWorkCheck/ChangeClass
        ChangeClass() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            params = $.extend({}, this.form, params);
            this.loading = true;
            $http.get("api/NetWorkCheck/ChangeClassEx", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功！',
                        type: 'success'
                    });

                    this.$emit('reloadList')
                    this.close()
                });
            });
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/Network/networkCheck/components/classListDialog/services.js